// extracted by mini-css-extract-plugin
module.exports = {"dialogModalContainer":"DialogModal_dialogModalContainer___Hrye"};